<style>
	.edi-mobilecheck {
		height: 100%;
		background-color: #eee;
	}
	.edi-mobilecheck .fieldset-1 {
		/*margin-top: 4em !important;*/
	}
	.edi-mobilecheck .mobile {
		text-align: center;
		line-height: 2.5em;
	}
	.edi-mobilecheck .mobile b {
		font-weight: normal;
		font-size: 1.5em;
	}
	.ui-content .ui-listview-inset {
		margin: 1em 0;
		-webkit-border-radius: .3125em;
		border-radius: .3125em;
	}
	.ui-btn {
		cursor: pointer;
		padding: .3em .8em;
		margin-right: .3em;
	}
	.edi-mobilecheck .bind {
		display: block;
		color: rgba(38, 159, 165, 0.63);
		text-align: center;
		font-size: 1.3em;
		margin-top: 1.5em;
	}
	.edi-mobilecheck .notfound {
		text-align: center;
	}
	.edi-mobilecheck .notfound:before {
		content: ' ';
		background: url('../assets/email/notfound.png') no-repeat 0 0;
		display: inline-block;
		width: 30px;
		height: 30PX;
		background-size: 30px;
		vertical-align: bottom;
		margin-right: 0.3em;
	}
</style>

<template>
	<div>
		<form v-if="emailData === null" class="ui-content edi-mobilecheck" @submit.prevent="onMobileSubmit">
			<p class="notfound fieldset-1">抱歉，您尚未绑定邮箱！</p>
			<fieldset class="ui-controlgroup">
				<input type="button" value="确定" class="submit" @click="onConfirm"/>
			</fieldset>
			<router-link to="/email-bind" class="bind">立即绑定邮箱</router-link>
		</form>
		<form v-else class="ui-content edi-mobilecheck" @submit.prevent="onMobileSubmit">
			<p class="mobile fieldset-1" style="margin-top: 0 !important">
				当前绑定邮箱<br/>
				<b>{{hideEmail}}</b><br>
				如需解绑，请先验证
			</p>
			<ul class="ui-listview ui-listview-inset">
				<li class="ui-listview-one-item" style="display: flex;border-bottom: 1px solid #ddd">
					<input type="text" name="verifyCode" v-model="verifyCode" placeholder="图形验证码" />
					<img :src="verifyCodeImg" @click="refreshVerifyCodeClick" style="height: 36px" />
				</li>
				<li class="ui-listview-one-item">
					<div class="ui-col-6"><input type="text" placeholder="验证码" v-model="code"/></div
						><div class="ui-col-4 ui-align-right"><email-code :type="5" :email="emailData" :uuid="verifyUUID" :verifyCode="verifyCode"></email-code></div>
				</li>
			</ul>
			<fieldset class="ui-controlgroup">
				<input type="submit" value="确定" class="submit" :class="{ 'ui-disable': submitDisable }"/>
			</fieldset>
		</form>
		<tips v-show="tips" :btnNum = "btnNum" :tipsFont = "tipsFont" v-on:tipStatus = "tipStatus"></tips>
		<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	</div>
</template>

<script>
import Tips from '../components/Tips'
import EmailCode from '../components/EmailCode'
import TipsAuto from '../components/TipsAuto'
export default {
	data () {
		return {
			tips: false,
			tipsauto: false,
			msg: [],
			btnNum: 1,
			tipsFont: '',
			emailData: this.$route.query.email,
			hasEmail: false,
			code: '',
			hideEmail: '',
			codePatrn: /^\d{4}$/,
			sec: 1500,
			verifyUUID: this.$fxUtils.createUUID(),
			verifyCode: ''
		}
	},
	created () {
		window.console.log(this.emailData)
		if (this.emailData !== null) {
			var arr = this.emailData.split('@')
			this.hideEmail = arr[0].substr(0, 3) + '***' + arr[0].substr(-3, 3) + '@' + arr[1]
		}
	},
	computed: {
		submitDisable () {
			return !this.code
		},
		verifyCodeImg () {
			return `/cldEdi/business/${this.verifyUUID}/getVerifyCode`
		}
	},
	components: {
		'email-code': EmailCode,
		'tips': Tips,
		'tips-auto': TipsAuto
	},
	methods: {
		refreshVerifyCodeClick () {
			this.verifyUUID = this.$fxUtils.createUUID()
		},
		tipStatus (msg) {
			this.tips = msg[0]
		},
		onConfirm () {
			this.$router.back()
		},
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		delaySkip (path) {
			var self = this
			setTimeout(() => {
				this.$router.push({path: path})
			}, self.sec)
		},
		onMobileSubmit () {
			// 解绑邮箱
			if (this.submitDisable) return
			if (this.code === '') {
				this.autoTips('验证码不能为空')
				return false
			} else if (!(this.codePatrn.test(this.code))) {
				this.autoTips('验证码为四位数字')
				return false
			}
			if (this.verifyCode === '') {
				this.autoTips('图形验证码不能为空')
				return false
			}
			this.$http.post('/cldEdi/business/unbindUserMail', {vCode: this.code, email: this.emailData}).then((response) => {
				if (response.body.result) {
					this.autoTips('解绑邮箱成功')
					this.delaySkip('/accounts')
				} else {
					this.autoTips(response.body.message)
				}
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// Email.vue?32b93bb2